import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Phone, ShoppingCart } from 'lucide-react';

interface MenuItemProps {
  name: string;
  price: string;
  description?: string;
  image: string;
  phoneNumber?: string;
}

const MenuItem = ({ name, price, description, image, phoneNumber }: MenuItemProps) => {
  // Generate SEO-friendly alt text with context
  const altText = `${name} - Authentic Mexican food at Junnior's Tacos Mexican Restaurant in Carrollton, GA`;
  
  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow flex flex-col h-full">
      <div className="aspect-[4/3] overflow-hidden bg-muted">
        <img 
          src={image} 
          alt={altText}
          title={`${name} | Junnior's Tacos Menu`}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex-1">
          <h3 className="font-semibold text-sm lg:text-lg mb-1">{name}</h3>
          <p className="text-sm lg:text-lg font-bold text-primary">{price}</p>
          {description && (
            <p className="hidden lg:block text-sm text-muted-foreground mt-2">{description}</p>
          )}
        </div>
        <div className="flex flex-col gap-2 mt-4">
          <Button className="w-full text-xs lg:text-sm" variant="default">
            <ShoppingCart className="mr-2 h-3 w-3 lg:h-4 lg:w-4" />
            Order Online
          </Button>
          {phoneNumber && (
            <Button 
              className="w-full text-xs lg:text-sm" 
              variant="outline"
              asChild
            >
              <a href={`tel:${phoneNumber}`}>
                <Phone className="mr-2 h-3 w-3 lg:h-4 lg:w-4" />
                Call to Order
              </a>
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};

export default MenuItem;
